// config
import { CountryISO } from 'ngx-intl-tel-input';
import { GiftCardImage, SideMenu } from './models/restaurant.model';
import { Address, DeliveryAddress } from './models/order.model';

export const BASE_URL_PATH = 'merchants';
export const GROUP_BASE_URL_PATH = 'groups';
export const GROUP_LOCATIONS_BASE_URL_PATH = 'locations/groups';
export const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const NO_SELECTED_CARD = 'different';
export const TABLE_LOCATION_KEY = 'tableLocationId';
export const LANDING_URL = window.location.href;

// Weekday index (0=Sun..6=Sat) -> DeliveryLocationHours day flag from FTF. (CF-32051)
export const DELIVERY_HOURS_DAY_FIELDS = [
  'schedule_on_sundays',
  'schedule_on_mondays',
  'schedule_on_tuesdays',
  'schedule_on_wednesdays',
  'schedule_on_thursdays',
  'schedule_on_fridays',
  'schedule_on_saturdays',
];
// ${environment.merchantId}

// Storage variables
export const STORAGE_CUSTOMER_DATA = 'customerData';
export const STORAGE_TAB_DATA = 'tabData';
export const PROMO_TILE_KEY = 'lastPromoTileShownAt';
export const DEEP_LINK_CATEGORY_KEY = 'categoryId';
export const DEEP_LINK_ITEM_KEY = 'deepLinkItemId';
export const DEEP_LINK_PINNED_KEY = 'deepLinkPinned';
export const LOCATION_MODAL_KEY = 'lastLocationModalShownAt';

export const PHONE_COUNTRIES = [
  CountryISO.UnitedStates,
  CountryISO.Australia,
  CountryISO.Canada,
  CountryISO.UnitedKingdom,
  CountryISO.PuertoRico,
  CountryISO.Guam,
  CountryISO.USVirginIslands,
  CountryISO.NorthernMarianaIslands,
  CountryISO.AmericanSamoa,
];

export const SERVICE_ITEM_MERCHANTS = ['3P74X474YMNDY', 'ZG3AZNS505J6G'];
export const SERVICE_ITEM_LOCATIONS = ['LYFVCR2S54Q0Z'];
export const ORDER_READY_SPECIAL_MERCHANTS = ['kitchenlabs'];

// Stone Creek config
export const STONE_CREEK_MERCHANT_ID = 'CFBWC96K81379';
export const STONE_CREEK_ABOUT_URL = 'https://www.stonecreekcoffee.com/our-story/';
export const STONE_CREEK_LEARN_MORE_URL = 'https://www.stonecreekcoffee.com/2021/10/26/new-mobile-app-coffee-geek-rewards/';

export const IMG_200 = '200x200/';
export const IMG_500 = '500x500/';
export const SQUARE_PROCESSOR = 'https://images-production-f.squarecdn.com/unsafe/';
export const SPICE_KITCHEN_IMG_PROCESS = 'https://res.cloudinary.com/kyoo-inc/image/fetch/e_bgremoval,q_100,b_black,e_vignette:30/';
export const NO_IMG_URL = './assets/icon/noimage.svg';

export const ATRIUM_LOGIN = 'atriumSuccess';

export const CITY_FLAVOR_WELCOME_CENTER_NAME = 'Terafab Trailer 6';
export const CITY_FLAVOR_WELCOME_CENTER_VISIBLE_DAYS = [1, 2, 3, 4, 5]; // Monday Tuesday

export const CITY_FLAVOR_LOCATIONS = [
  'LJX9BRZRA497B',
  'LJY848EBEWBC3',
  'L8ZJDN55J7VA1',
  'L00Q8JCK377VT',
  'A6M966PYW6C1C',
  'LR6D2VC0WNM1E',
  'LE8YKANPRF1ZD',
  '1GSTTH8CT7RW3',
  'LYFQYB2NW72GW',
  'LFF735NAD7KMF',
  'A917PM9NK3XWA',
  'LAVCD4JKA34QM',
  'F2ZDXWRVZMXKJ',
  'LWC9TJSGM4QWW',
  'LBA7YWJHH2RJX',
  'LHTNQQXKD0RYK',
  'LTHS7FFRH6225',
  'LVNA7DQQC0DEK',
  'LRQG7DF10FFJ5',
  'LKFP9HYRCB3QT',
  'M87DRCWGVE72P',
  'L3PX6RW9CHEDG',
  'L27TP9N566W1K',
  'LPWTZMYYYZ0T9',
  'L3KMDBEVEZ8PG',
  'LN2K9W39R43KY',
  'LY4XRYAPKYTV6',
  'LTYD3KJQ5ZV1H',
  '2WFXT1822Z0FY',
  'L2WNAE8CABQ8X',
  'LKK0XG3GA02V5',
  'D259GF98MGGHJ',
  'LWCPFPPHJXVPB',
  'LWJM8ZZAN1SB1',
  'LD25CK0VV7A62',
  'L6364PF41KV15',
  'L9EQDS6B1KMBG',
  'LV3HSS8ZSJR63',
  'L2BYTHYAWG29A',
  'L1BFKE1BZERDA',
  'LMRA6X0NW0V1H',
  'LPDAZR45B84P2',
  'L3QVX574ASQ7K',
  'LMWH7B0CD44FA',
  'LYRJ86JQDQCNY',
  'LHXE6PEJYKFJX',
  'LMTSDQGAWBEGC',
  'L9G0XMEG4HTAR',
  'LWXQ602HBEACC',
  'L6NBC60Z0TT27',
  'LBQ3G4N1QRSJE',
  'L9E4BHS5JZTSF',
  'L3B4W44Z7TN49',
  'L6HSF3JZ573AM',
  'LN40X1Z3ANAXM',
  'LY65QTMVC5WBW',
  'LSVFJZ2B7WZVT',
  'BQECV8SJADEH6',
  'LJYS4S3F3FWGX',
  'L0GK4R7CBJA5X',
  'LYM7DM0XN8F6M',
  'LAFCXWM1QY7NP',
  'LNJDNPHVDBTCE',
  'LM3MVYA995PSX',
  'LEKF4SVBEHXZC',
  'L27K1VAEC03SZ',
  'LPJX7D65YRMQ2',
  'LKXYXRFB6A8DK',
  'L8ZE2G4VEH4MC',
  'LF246W0424G8B',
  'L0C6GAPF0V151',
  'LF6Z9VRE2N3B9',
  'LPE7317E8QV5M',
  'LZYPDDFJYBAG8',
  'LFETYZF55TZKF',
  'LNWJ5VTN2VFM4',
  'LYZ6AJ8RJD1W8',
  'LPRRZE0CSN9VM',
  'L7E2KTFPAC5YH',
  'LTBJM3YBCCADZ',
  'LF1J42P3Y5RBQ',
  'L720GTWBXDNNF',
  'LC4D9B470SFFE',
  'LC6Z4V3H2872K',
  'LDBSER8AGP971',
  'LN471MG4YEXGE',
  'LHGWREVS5EEHM',
  'LV40FB3R07CF5',
  'LW5XVPA403PF8',
  'L57AB38Y62090',
  'LKX23XZZ6TNT8',
  'LCTR98FKF6WW9',
  'LS6JGV0BDZNV7',
  'LX5D80FNSZPBM',
  'LX8NM7ZG78MET',
  'LB7DJAA461D36',
  'L695756E9T3EW',
  'L4RAY3ZXG3A0K',
  'L8Y5QR3KWGZWR',
  'LGJ8ERR5PQ90Q',
  'LGJ5VS2P3FMN7',
  'L3RQW2M9E9XH4',
  'LPYNXQE4797D0',
  'L14105ASMV3M2',
  'L2B472K60EQZH',
  'L408AM1PYXB1G',
  'L56XVV469QMKG',
  'L5JVYX0PCF56Q',
  'L5VN6ZX5BVPNM',
  'L73F9KN8Z3382',
  'LA3J3DYBFKRD1',
  'LBQ2K6E9XTD5Z',
  'LCS13CEEPPCX8',
  'LEABBJWBRT1P5',
  'LFNJRFGW5GNHG',
  'LHX0V1P9M2HRK',
  'LJQC7Q98AJ6F8',
  'LJZWZRN9Q2R9C',
  'LKP7W2RXH9WTV',
  'LKZ27539PV2KN',
  'LP73Q7EDC3523',
  'LSFK546TZRW3D',
  'LSQTSXV7CNHQZ',
  'LXFRYM9M3VYQ6',
  'LZ7N92MM26K6F',
  'LZ8AXSHREX1MG',
  'L5VYNR45SA0K7',
  'LSET8Y8FSH1QS',
  'L9WJ25X6A6YT6',
  'LSQHRD7PDHAC6',
  'LW9F0S9Z654PK',
  'L9KV5M96KGDP8', // sandbox test group
  'CX6XZEVDBXREY' // staging test group
];

export const SIDE_MENU: SideMenu[] = [
  new SideMenu(1, 'About', false, false, 'icon-user'),
  new SideMenu(2, 'Contact Us', false, false,'icon-house'),
];

export const ACCOUNT_MENU: SideMenu[] = [
  new SideMenu(1, 'Account Info', false, true,'icon-user'),
  new SideMenu(2, 'Loyalty Rewards', false, true,'icon-cake'),
  new SideMenu(3, 'Payment Methods', false, true,'icon-credit-card'),
  new SideMenu(4, 'Order History', false, false,'icon-clock-outline'),
  new SideMenu(5, 'Buy an eGift Card', false, true, 'icon-gift'),
  new SideMenu(7, 'Notifications', false, false, 'icon-bell'),
  new SideMenu(8, 'Settings', false, false, 'icon-cog'),
  new SideMenu(9, 'Subscriptions', true, true, 'icon-package'),
  new SideMenu(6, 'Sign In', false, false,'icon-sign-out'),
];

export const GROUP_ACCOUNT_MENU: SideMenu[] = [
  new SideMenu(4, 'Order History', false, false,'icon-clock-outline'),
  new SideMenu(6, 'Sign In', false, false,'icon-sign-out'),
];

export const DEFAULT_GIFTCARD: GiftCardImage[] = [
  new GiftCardImage('1', 'https://kyoo-sandbox-assets.s3.us-east-1.amazonaws.com/03fbca1e-c25e-4ba5-b41a-b0c1c461db44.png')
];

export const TIMES = [
  { id: 1, label: "Open Now" },
  { id: 2, label: "Breakfast", startTime: "03:00", endTime: "11:00" },
  { id: 3, label: "Lunch", startTime: "11:00", endTime: "15:00" },
  { id: 4, label: "Dinner", startTime: "15:00", endTime: "24:00" }
];
